// extracted by css-extract-rspack-plugin
export default {"adminId":"adminId-wvEaFI","adminIdCopied":"adminIdCopied-qax9Zc"};